export type LiqIntelRecentProvider = "openai" | "perplexity" | "gemini";

export interface LiqIntelRecentView {
  company: string;
  cert?: number;
  provider: LiqIntelRecentProvider;
  viewedAt: number;
}

const STORAGE_KEY = "liqintel-recently-viewed";
const MAX_ITEMS = 8;

function isRecentProvider(value: unknown): value is LiqIntelRecentProvider {
  return value === "openai" || value === "perplexity" || value === "gemini";
}

export function loadLiqIntelRecentlyViewed(): LiqIntelRecentView[] {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return [];

    return parsed
      .filter((item): item is LiqIntelRecentView => {
        if (!item || typeof item !== "object") return false;
        const entry = item as LiqIntelRecentView;
        return (
          typeof entry.company === "string" &&
          entry.company.trim() !== "" &&
          isRecentProvider(entry.provider) &&
          typeof entry.viewedAt === "number"
        );
      })
      .slice(0, MAX_ITEMS);
  } catch {
    return [];
  }
}

export function rememberLiqIntelView(entry: {
  company: string;
  cert?: number;
  provider: LiqIntelRecentProvider;
}): LiqIntelRecentView[] {
  const company = entry.company.trim();
  if (!company) return loadLiqIntelRecentlyViewed();

  const cert = Number.isFinite(entry.cert) ? entry.cert : undefined;
  const nextItem: LiqIntelRecentView = {
    company,
    provider: entry.provider,
    viewedAt: Date.now(),
    ...(cert !== undefined ? { cert } : {}),
  };

  const deduped = loadLiqIntelRecentlyViewed().filter((item) => {
    if (item.company !== company) return true;
    if (cert === undefined) return item.cert === undefined;
    return item.cert !== cert;
  });

  const next = [nextItem, ...deduped].slice(0, MAX_ITEMS);
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  return next;
}
